/**
 * nara-kal-guard.js — un coș = un singur grup: magazinul obișnuit, ediția KAL sau o
 * campanie de precomandă (Sandnes 01 ș.a.).
 *
 * KAL și precomenzile se livrează împreună la finalul campaniei, deci nu au voie să stea
 * în același coș cu produse obișnuite, nici între ele.
 *
 * Cum funcționează:
 *  - Adăugările se ștampilează: KAL cu properties[_kal]=1 (blocks/buy-buttons.liquid,
 *    snippets/quick-add.liquid, calculatorul KAL), precomenzile cu
 *    properties[_pre]=<campanie> (blocks/nara-precomanda-nuante.liquid).
 *  - Interceptăm fetch-ul către /cart/add. Dacă adăugarea ar produce un coș
 *    mixt, arătăm un dialog: fie golim coșul și adăugăm, fie renunțăm.
 *  - Liniile deja în coș se recunosc după aceleași proprietăți sau, ca rezervă,
 *    după handle (kal-01-*, pre-sandnes-01-*).
 *
 * Mostrele (samples-guard.js) nu sunt afectate.
 */
(() => {
  const KAL_HANDLE_RE = /^kal-\d+-/;
  /* pre-sandnes-01-peer-gynt → sandnes-01 */
  const PRE_HANDLE_RE = /^pre-(.+?-\d+)-/;

  const I18N = {
    ro: {
      kalIntoNormal:
        'Produsele din Ediția KAL se comandă separat de restul magazinului, pentru că se livrează împreună la finalul precomenzii. Golim coșul ca să adaugi acest produs KAL?',
      normalIntoKal:
        'Coșul tău conține produse din Ediția KAL, care se comandă separat și se livrează la finalul precomenzii. Golim coșul ca să adaugi acest produs?',
      confirm: 'Golește coșul și adaugă',
      cancel: 'Păstrează coșul',
      blocked: 'Produsele KAL se comandă separat.',
      preIntoOther:
        'Precomanda se comandă separat de restul magazinului și de ediția KAL, pentru că pleacă abia când sosesc firele. Golim coșul ca să adaugi acest fir?',
      otherIntoPre:
        'Coșul tău conține fire din precomandă, care se comandă separat și pleacă abia când sosesc firele. Golim coșul ca să adaugi acest produs?',
      preBlocked: 'Precomanda se comandă separat.'
    },
    en: {
      kalIntoNormal:
        'KAL Edition products are ordered separately from the rest of the shop, because they ship together at the end of the preorder. Empty the cart to add this KAL product?',
      normalIntoKal:
        'Your cart contains KAL Edition products, which are ordered separately and ship at the end of the preorder. Empty the cart to add this product?',
      confirm: 'Empty cart and add',
      cancel: 'Keep my cart',
      blocked: 'KAL products are ordered separately.',
      preIntoOther:
        'The preorder is ordered separately from the rest of the shop and from the KAL edition, because it ships only once the yarn arrives. Empty the cart to add this yarn?',
      otherIntoPre:
        'Your cart contains preorder yarn, which is ordered separately and ships only once the yarn arrives. Empty the cart to add this product?',
      preBlocked: 'The preorder is ordered separately.'
    },
    bg: {
      kalIntoNormal:
        'Продуктите от изданието KAL се поръчват отделно от останалите, защото се изпращат заедно в края на предварителната поръчка. Да изпразним ли количката, за да добавиш този KAL продукт?',
      normalIntoKal:
        'Количката ти съдържа продукти от изданието KAL, които се поръчват отделно и се изпращат в края на предварителната поръчка. Да изпразним ли количката, за да добавиш този продукт?',
      confirm: 'Изпразни количката и добави',
      cancel: 'Запази количката',
      blocked: 'KAL продуктите се поръчват отделно.',
      preIntoOther:
        'Предварителната поръчка се прави отделно от останалите продукти и от изданието KAL, защото се изпраща чак когато прежата пристигне. Да изпразним ли количката, за да добавиш тази прежда?',
      otherIntoPre:
        'Количката ти съдържа прежда от предварителна поръчка, която се поръчва отделно и се изпраща чак когато прежата пристигне. Да изпразним ли количката, за да добавиш този продукт?',
      preBlocked: 'Предварителната поръчка се прави отделно.'
    },
    hu: {
      kalIntoNormal:
        'A KAL kiadás termékeit külön rendelésben lehet megvásárolni, mert az előrendelés végén együtt szállítjuk őket. Ürítsük ki a kosarat, hogy hozzáadd ezt a KAL terméket?',
      normalIntoKal:
        'A kosaradban KAL kiadású termékek vannak, amelyeket külön kell megrendelni, és az előrendelés végén szállítjuk őket. Ürítsük ki a kosarat, hogy hozzáadd ezt a terméket?',
      confirm: 'Kosár ürítése és hozzáadás',
      cancel: 'Kosár megtartása',
      blocked: 'A KAL termékeket külön kell megrendelni.',
      preIntoOther:
        'Az előrendelést a bolt többi termékétől és a KAL kiadástól külön kell leadni, mert csak a fonal megérkezése után szállítjuk. Ürítsük ki a kosarat, hogy hozzáadd ezt a fonalat?',
      otherIntoPre:
        'A kosaradban előrendelt fonal van, amelyet külön kell megrendelni, és csak a fonal megérkezése után szállítjuk. Ürítsük ki a kosarat, hogy hozzáadd ezt a terméket?',
      preBlocked: 'Az előrendelést külön kell leadni.'
    }
  };

  function t() {
    const lang = (document.documentElement.lang || 'ro').slice(0, 2).toLowerCase();
    return I18N[lang] || I18N.ro;
  }

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const nativeFetch = window.fetch.bind(window);

  function isCartAddUrl(input) {
    const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input && input.url;
    return typeof url === 'string' && url.includes('/cart/add');
  }

  /* Grupul unui set de proprietăți: 'kal', 'pre:<campanie>' sau null (magazin obișnuit). */
  function groupOfProps(get) {
    const pre = get('_pre');
    if (pre) return 'pre:' + pre;
    if (String(get('_kal') || '') === '1') return 'kal';
    return null;
  }

  /** Grupul adăugării curente, citit din marcajul din body (form, URL-encoded sau JSON). */
  function bodyGroup(body) {
    if (!body) return 'normal';
    if (body instanceof FormData || body instanceof URLSearchParams) {
      return groupOfProps((k) => body.get('properties[' + k + ']')) || 'normal';
    }
    if (typeof body === 'string') {
      const t = body.trim();
      if (t.startsWith('{')) {
        try {
          const j = JSON.parse(t);
          const first = (j.items && j.items[0]) || j;
          const props = (first && first.properties) || {};
          return groupOfProps((k) => props[k]) || 'normal';
        } catch (e) { /* cade pe căutarea de text de mai jos */ }
      }
      const params = new URLSearchParams(t);
      const g = groupOfProps((k) => params.get('properties[' + k + ']'));
      if (g) return g;
      if (t.includes('"_kal"')) return 'kal';
    }
    return 'normal';
  }

  function lineGroup(item) {
    const props = item.properties || {};
    const g = groupOfProps((k) => props[k]);
    if (g) return g;
    const handle = item.handle || '';
    if (KAL_HANDLE_RE.test(handle)) return 'kal';
    const m = handle.match(PRE_HANDLE_RE);
    if (m) return 'pre:' + m[1];
    return 'normal';
  }

  async function getCart() {
    const res = await nativeFetch(root + 'cart.js', { credentials: 'same-origin' });
    return res.json();
  }

  /** Dialog alb/negru, radius 0, pe stilul Design System v2. Rezolvă true = golește și adaugă. */
  function askUser(message) {
    return new Promise((resolve) => {
      const strings = t();
      const overlay = document.createElement('div');
      overlay.setAttribute('style', 'position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;padding:20px;');

      const box = document.createElement('div');
      box.setAttribute('role', 'alertdialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('style', 'background:#fff;color:#000;max-width:420px;width:100%;padding:28px 24px;border:1px solid #000;border-radius:0;font-family:Montserrat,sans-serif;');

      const text = document.createElement('p');
      text.textContent = message;
      text.setAttribute('style', 'margin:0 0 20px;font-size:14px;line-height:1.55;');

      const actions = document.createElement('div');
      actions.setAttribute('style', 'display:flex;flex-direction:column;gap:10px;');

      const btnStyle = 'display:block;width:100%;padding:13px 16px;border-radius:0;font-size:12px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;cursor:pointer;font-family:inherit;';
      const confirmBtn = document.createElement('button');
      confirmBtn.type = 'button';
      confirmBtn.textContent = strings.confirm;
      confirmBtn.setAttribute('style', btnStyle + 'background:#000;color:#fff;border:1px solid #000;');

      const cancelBtn = document.createElement('button');
      cancelBtn.type = 'button';
      cancelBtn.textContent = strings.cancel;
      cancelBtn.setAttribute('style', btnStyle + 'background:#fff;color:#000;border:1px solid #000;');

      function close(result) {
        overlay.remove();
        document.removeEventListener('keydown', onKey);
        resolve(result);
      }
      function onKey(e) {
        if (e.key === 'Escape') close(false);
      }

      confirmBtn.addEventListener('click', () => close(true));
      cancelBtn.addEventListener('click', () => close(false));
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) close(false);
      });
      document.addEventListener('keydown', onKey);

      actions.append(confirmBtn, cancelBtn);
      box.append(text, actions);
      overlay.append(box);
      document.body.append(overlay);
      confirmBtn.focus();
    });
  }

  /** Răspuns sintetic în formatul de eroare Shopify: product-form.js îl afișează sub buton. */
  /* `pre` = conflictul implică o precomandă (adăugată sau deja în coș), altfel e KAL. */
  function blockedResponse(pre) {
    const strings = t();
    const msg = pre ? strings.preBlocked : strings.blocked;
    return new Response(
      JSON.stringify({ status: 422, message: msg, description: msg }),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    );
  }

  window.fetch = async function (input, init) {
    if (!isCartAddUrl(input)) return nativeFetch(input, init);

    /* Cos gol inseamna zero linii cu care noul produs ar putea intra in conflict,
       deci verdictul e cunoscut fara sa mai cerem /cart.js. Asta scoate un dus-intors
       same-origin de pe drumul fiecarei PRIME adaugari in cos, adica majoritatea.
       `naraCartIsEmpty()` (layout/theme.liquid) combina `cart.item_count` randat de
       server cu `sessionStorage['cart-count']` scris de cart-icon.js, si raspunde
       "nu e gol" daca oricare dintre ele vede linii. Orice indoiala inseamna ca
       verificarea completa de mai jos ruleaza normal. */
    if (typeof window.naraCartIsEmpty === 'function' && window.naraCartIsEmpty()) {
      const res = await nativeFetch(input, init);
      /* Auto-corectie: dupa o adaugare reusita cosul NU mai e gol, deci urmatoarea
         adaugare din aceeasi pagina trece prin verificarea completa. Nu ne bazam pe
         evenimentul `cart:update`, care e emis de product-form.js, nu de Shopify:
         orice cale de adaugare scrisa de mana l-ar rata si garda ar ramane oprita. */
      if (res && res.ok) window.naraCartCount = (window.naraCartCount || 0) + 1;
      return res;
    }

    const body = init && init.body;
    let incoming;
    let cart;
    try {
      incoming = bodyGroup(body);
      cart = await getCart();
    } catch (e) {
      // Dacă nu putem verifica, nu blocăm vânzarea.
      return nativeFetch(input, init);
    }

    const groups = new Set(((cart && cart.items) || []).map(lineGroup));
    groups.delete(incoming);
    if (!groups.size) return nativeFetch(input, init);

    const strings = t();
    const cartHasPre = [...groups].some((g) => g.startsWith('pre:'));
    let message;
    if (incoming.startsWith('pre:')) message = strings.preIntoOther;
    else if (cartHasPre) message = strings.otherIntoPre;
    else message = incoming === 'kal' ? strings.kalIntoNormal : strings.normalIntoKal;
    const emptyAndAdd = await askUser(message);
    if (!emptyAndAdd) return blockedResponse(incoming.startsWith('pre:') || cartHasPre);

    await nativeFetch(root + 'cart/clear.js', { method: 'POST', credentials: 'same-origin' });
    return nativeFetch(input, init);
  };
})();
